import { render, staticRenderFns } from "./ReceptionRecipientView.vue?vue&type=template&id=73d6a998&scoped=true&"
import script from "./ReceptionRecipientView.vue?vue&type=script&lang=ts&"
export * from "./ReceptionRecipientView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73d6a998",
  null
  
)

export default component.exports